"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.repayPartialPerpetualLoan = void 0;
const constants_1 = require("../../../../constants");
const types_1 = require("../../../../types");
const offer_1 = require("../../offer");
const helpers_1 = require("./../../../../helpers");
const anchor_1 = require("@project-serum/anchor");
const repayPartialPerpetualLoan = ({ programId, connection, args, addComputeUnits, accounts, sendTxn, }) => __awaiter(void 0, void 0, void 0, function* () {
    const program = (0, helpers_1.returnAnchorProgram)(programId, connection);
    const instructions = [];
    const repaidBondTradeTransaction = anchor_1.web3.Keypair.generate();
    const [mutualBondTradeTxnVault] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.MUTUAL_BOND_TRADE_TXN_VAULT)], program.programId);
    const [oldBondOfferVault, oldBondOfferVaultBump] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.BOND_OFFER_VAULT_PREFIX), accounts.oldBondOffer.toBuffer()], program.programId);
    const [repaymentCall, repaymentCallBump] = yield anchor_1.web3.PublicKey.findProgramAddress([
        constants_1.ENCODER.encode(constants_1.REPAYMENT_CALL_PREFIX),
        accounts.lender.toBuffer(),
        accounts.oldBondTradeTransaction.toBuffer(),
    ], program.programId);
    const modifyComputeUnits = anchor_1.web3.ComputeBudgetProgram.setComputeUnitLimit({
        units: Math.round(800000 + Math.ceil(Math.random() * 10000)),
    });
    const requestHeap = anchor_1.web3.ComputeBudgetProgram.setComputeUnitPrice({ microLamports: 6000 });
    instructions.push(requestHeap);
    if (!!addComputeUnits)
        instructions.push(modifyComputeUnits);
    instructions.push(yield program.methods
        .repayPartialPerpetualLoan(new anchor_1.BN(args.fractionToRepay))
        .accountsStrict({
        user: accounts.userPubkey,
        fbond: accounts.fbond,
        lender: accounts.lender,
        oldBondTradeTransaction: accounts.oldBondTradeTransaction,
        repaidBondTradeTransaction: repaidBondTradeTransaction.publicKey,
        protocolFeeReceiver: accounts.protocolFeeReceiver,
        systemProgram: anchor_1.web3.SystemProgram.programId,
        rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
        uninitializedOldBondOfferV2: accounts.oldBondOffer,
        mutualBondTradeTxnVault: mutualBondTradeTxnVault,
        bondOfferVault: oldBondOfferVault,
        uninitializedRepaymentCall: repaymentCall,
    })
        .instruction());
    const transaction = new anchor_1.web3.Transaction();
    for (let instruction of instructions)
        transaction.add(instruction);
    const signers = [repaidBondTradeTransaction];
    yield sendTxn(transaction, signers);
    const partialLoanValueToRepay = (args.optimistic.bondTradeTransaction.solAmount * args.fractionToRepay) / constants_1.BASE_POINTS;
    const now = (0, offer_1.nowInSeconds)();
    const interestSol = (0, offer_1.calculateCurrentInterestSolPure)({
        loanValue: partialLoanValueToRepay,
        startTime: args.optimistic.bondTradeTransaction.soldAt,
        currentTime: now,
        rateBasePoints: args.optimistic.bondTradeTransaction.amountOfBonds,
    });
    const repayFeeSol = (0, offer_1.calculateCurrentInterestSolPure)({
        loanValue: partialLoanValueToRepay,
        startTime: args.optimistic.bondTradeTransaction.soldAt,
        currentTime: now,
        rateBasePoints: constants_1.REPAY_FEE_APR,
    });
    const amountToReturn = partialLoanValueToRepay + interestSol + repayFeeSol;
    const updatedBond = Object.assign(Object.assign({}, args.optimistic.fraktBond), { currentPerpetualBorrowed: args.optimistic.fraktBond.currentPerpetualBorrowed - amountToReturn, lastTransactedAt: (0, offer_1.nowInSeconds)() });
    //  optimisticRepayFraktBond(args.optimistic.fraktBond, amountToReturn);
    const updatedBondTradeTransaction = Object.assign(Object.assign({}, args.optimistic.bondTradeTransaction), { solAmount: args.optimistic.bondTradeTransaction.solAmount - partialLoanValueToRepay, redeemResult: types_1.RedeemResult.PartialRepay, currentRemainingLent: args.optimistic.bondTradeTransaction.currentRemainingLent - partialLoanValueToRepay, lenderFullRepaidAmount: args.optimistic.bondTradeTransaction.lenderFullRepaidAmount + partialLoanValueToRepay, borrowerFullRepaidAmount: args.optimistic.bondTradeTransaction.borrowerFullRepaidAmount + partialLoanValueToRepay });
    const repaidBondTradeTransactionOptimistic = Object.assign(Object.assign({}, args.optimistic.bondTradeTransaction), { publicKey: repaidBondTradeTransaction.publicKey.toBase58(), bondTradeTransactionState: types_1.BondTradeTransactionV2State.PerpetualPartialRepaid, solAmount: partialLoanValueToRepay, feeAmount: 0, redeemedAt: (0, offer_1.nowInSeconds)(), redeemResult: (0, helpers_1.getNewRedeemResult)(args.optimistic.bondTradeTransaction.redeemResult, types_1.RedeemResult.PartialRepay), partialRepaySnapshot: partialLoanValueToRepay, interestSnapshot: interestSol + repayFeeSol, currentRemainingLent: args.optimistic.bondTradeTransaction.currentRemainingLent - partialLoanValueToRepay, lenderFullRepaidAmount: args.optimistic.bondTradeTransaction.lenderFullRepaidAmount + partialLoanValueToRepay, borrowerFullRepaidAmount: args.optimistic.bondTradeTransaction.borrowerFullRepaidAmount + partialLoanValueToRepay });
    const updatedOldBondOffer = args.optimistic.oldBondOffer
        ? (0, offer_1.optimisticRepayUpdateBondingBondOffer)(args.optimistic.oldBondOffer, partialLoanValueToRepay, interestSol, true, args.optimistic.bondTradeTransaction.bondTradeTransactionState !==
            types_1.BondTradeTransactionV2State.PerpetualManualTerminating)
        : args.optimistic.oldBondOffer;
    const optimisticResult = {
        fraktBond: updatedBond,
        bondTradeTransaction: updatedBondTradeTransaction,
        repaidBondTradeTransaction: repaidBondTradeTransactionOptimistic,
        oldBondOffer: updatedOldBondOffer,
    };
    const repaymentCallSolAmount = partialLoanValueToRepay + interestSol;
    const optimisticRepaymentCall = args.optimistic.repaymentCall ? Object.assign(Object.assign({}, args.optimistic.repaymentCall), { callAmount: args.optimistic.repaymentCall.callAmount > repaymentCallSolAmount ?
            args.optimistic.repaymentCall.callAmount - repaymentCallSolAmount : 0, lastRepaidAt: (0, offer_1.nowInSeconds)(), lastUpdatedAt: (0, offer_1.nowInSeconds)() }) : args.optimistic.repaymentCall;
    return {
        instructions,
        signers,
        optimisticResults: [Object.assign(Object.assign({}, optimisticResult), { repaymentCall: optimisticRepaymentCall })],
    };
});
exports.repayPartialPerpetualLoan = repayPartialPerpetualLoan;
